import React from "react";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import flags from "react-phone-number-input/flags";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import AddressAutocomplete from "./GooglePlaces.tsx";
import "react-phone-number-input/style.css";

interface FormStep1Props {
  register: any;
  errors: any;
  control: any;
  setValue: Function;
}

export default function FormStep1({ register, errors, control, setValue }: FormStep1Props) {


  return (
    <section>
      {/* <h2 className="font-semibold text-2xl mb-4">Contact Information</h2> */}

      {/* First + Last Name */}
      <div className="flex mb-3 gap-x-4">
  <div className="w-1/2">
    <label className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
      First Name
    </label>
    <input className="text-input" {...register("First name")} />
  </div>

  <div className="w-1/2">
    <label className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
      Last Name
    </label>
    <input className="text-input" {...register("Last name")} />
  </div>
</div>

      {/* Email + Phone */}
      <div className="flex gap-x-4 mb-3">
  <div className="w-1/2">
    <label className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
      Email
    </label>
    <input
      id="Email"
      className="text-input"
      type="email"
      placeholder="Email"
      {...register("Email", {
        required: false,
        pattern: /^\S+@\S+$/i,
      })}
    />
  </div>

  <div className="w-1/2">
    <label className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
      Phone
    </label>
    <PhoneInputWithCountry
      id="phone"
      className="text-input"
      name="phone"
      flags={flags}
      control={control}
      defaultCountry="US"
      rules={{
        required: true,
        validate: (value) => isPossiblePhoneNumber(value),
      }}
    />
    {errors["phone"] && <p className="error-message">Invalid Phone</p>}
  </div>
</div>

      {/* Address Autocomplete */}
      <div className="flex flex-wrap mb-3">
        <div className="w-full md:w-4/4 mb-3 md:mb-0">
          <label className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Address Search</label>
          <AddressAutocomplete setValue={setValue} />
        </div>
      </div>

      {/* Address + Apt */}
      <div className="flex mb-3 gap-x-4">
  <div className="w-3/4">
    <label className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
      Address
    </label>
    <input className="text-input" readOnly {...register("Address")} />
  </div>

  <div className="w-1/4">
    <label className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
      Apt / Unit
    </label>
    <input className="text-input" {...register("Apartment")} />
  </div>
</div>

      {/* City + State + Postal */}
      {/* Row 1: City + State */}
<div className="flex gap-x-4 mb-3">
  <div className="w-1/2">
    <label className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
      City
    </label>
    <input
      id="City"
      className="text-input"
      type="text"
      placeholder="City"
      readOnly
      {...register("City")}
    />
  </div>

  <div className="w-1/2">
    <label className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
      State / Region
    </label>
    <input
      id="State"
      className="text-input"
      type="text"
      placeholder="State/Region"
      readOnly
      {...register("State")}
    />
  </div>
</div>

{/* Row 2: Postal Code + Country */}
<div className="flex gap-x-4 mb-3">
  <div className="w-1/2">
    <label className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
      Postal Code
    </label>
    <input
      id="PostalCode"
      className="text-input"
      type="text"
      placeholder="Postal Code"
      readOnly
      {...register("PostalCode")}
    />
  </div>

  <div className="w-1/2">
    <label className="text-left block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Country">
      Country
    </label>
    <input
      id="Country"
      className="text-input"
      type="text"
      placeholder="Country"
      readOnly
      {...register("Country", {
        required: false,
        maxLength: 40,
      })}
    />
  </div>
</div>
    </section>
  );
}
